import { render, staticRenderFns } from "./NotVipBottom.vue?vue&type=template&id=5dc67418&scoped=true&"
import script from "./NotVipBottom.vue?vue&type=script&lang=ts&"
export * from "./NotVipBottom.vue?vue&type=script&lang=ts&"
import style0 from "./NotVipBottom.vue?vue&type=style&index=0&id=5dc67418&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc67418",
  null
  
)

export default component.exports